export default __webpack_public_path__ + "assets/images/5f39e89bab091d63f685d056f30ab050.jpg";